import React, { Component, Fragment } from "react";
import Burger from "../../components/Burger/Burger";
import BuildControls from "../../components/Burger/BuildControls/BuildControls";
import Modal from "../../components/UI/Modal/Modal";
import OrderSummary from "../../components/Burger/OrderSummary/OrderSummary";
import Button from "../../components/UI/Button/Button";

class BurgerBuilder extends Component {
  state = {
    ingredints: {
      salad: { amount: 0, price: 3 },
      shawrma: { amount: 0, price: 5 },
      cheese: { amount: 0, price: 2 },
      meat: { amount: 0, price: 7 }
    },
    totalPrice: 0,
    order: false
  };

  moreHandle = type => {
    this.setState(prev => {
      prev.ingredints[type].amount += 1;
      prev.totalPrice +=
        prev.ingredints[type].price * prev.ingredints[type].amount;
      return prev;
    });
  };

  lessHandle = type => {
    this.setState(prev => {
      prev.totalPrice -=
        prev.ingredints[type].price * prev.ingredints[type].amount;
      if (prev.ingredints[type].amount !== 0) prev.ingredints[type].amount -= 1;

      return prev;
    });
  };
  openModalHandle = () => {
    this.setState(prev => {
      prev.order = true;
      return prev;
    });
  };
  closeModalHandle = () => {
    this.setState(prev => {
      prev.order = false;
      return prev;
    });
  };

  orderHandler = () => {
    alert("order Now!!");
    this.closeModalHandle();
  };
  render() {
    return (
      <Fragment>
        <Modal show={this.state.order} onCloseModal={this.closeModalHandle}>
          <OrderSummary
            ingredints={this.state.ingredints}
            totalPrice={this.state.totalPrice}
          />

          <Button onClicked={this.orderHandler} success={true}>
            Checkout
          </Button>
          <Button onClicked={this.closeModalHandle}>Cancel</Button>
        </Modal>
        <Burger ingredints={this.state.ingredints} />
        <BuildControls
          ingredints={this.state.ingredints}
          onMore={this.moreHandle}
          onLess={this.lessHandle}
          onOrder={this.openModalHandle}
          totalPrice={this.state.totalPrice}
        />
      </Fragment>
    );
  }
}

export default BurgerBuilder;
